// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IServiceForDto
 */
export interface IServiceForDto {
    /**
     * 
     * @type {string}
     * @memberof IServiceForDto
     */
    relationship_type?: IServiceForDtoRelationshipTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IServiceForDto
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IServiceForDto
     */
    is_hidden?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IServiceForDto
     */
    is_view_name_allowed?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IServiceForDto
     */
    birth_on?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IServiceForDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the IServiceForDto interface.
 */
export function instanceOfIServiceForDto(value: object): value is IServiceForDto {
    return true;
}

export function IServiceForDtoFromJSON(json: any): IServiceForDto {
    return IServiceForDtoFromJSONTyped(json, false);
}

export function IServiceForDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IServiceForDto {
    if (json == null) {
        return json;
    }
    return {
        
        'relationship_type': json['relationship_type'] == null ? undefined : json['relationship_type'],
        'name': json['name'] == null ? undefined : json['name'],
        'is_hidden': json['is_hidden'] == null ? undefined : json['is_hidden'],
        'is_view_name_allowed': json['is_view_name_allowed'] == null ? undefined : json['is_view_name_allowed'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
    };
}

export function IServiceForDtoToJSON(json: any): IServiceForDto {
    return IServiceForDtoToJSONTyped(json, false);
}

export function IServiceForDtoToJSONTyped(value?: IServiceForDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationship_type': value['relationship_type'],
        'name': value['name'],
        'is_hidden': value['is_hidden'],
        'is_view_name_allowed': value['is_view_name_allowed'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
    };
}

